<div class="redeem-container text-center p-4">
  @if (isLoading) {
    <div class="mb-3">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-2">Verifying invitation...</p>
    </div>
  }

  @if (redemptionMessage) {
    <div class="redemption-text mt-2">
      <p class="text-danger">{{ redemptionMessage }}</p>
      @if (inviteCode) {
        <button class="btn btn-outline-primary mt-2" (click)="goToSignUp()">
          Sign Up Instead
        </button>
      }
    </div>
  }
</div>
